"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateImage = void 0;
var _utils = require("../../utils");
var validateImage = function validateImage(image) {
  if (!image) {
    _utils.toast.error({
      title: 'Image error',
      description: 'Please upload an image or wait until it is being processed.'
    });
    return false;
  }
  return true;
};
exports.validateImage = validateImage;